var map = {
	"./bg.json": [
		4378,
		378
	],
	"./en.json": [
		4174,
		174
	],
	"./es.json": [
		6725,
		725
	],
	"./fr.json": [
		4605,
		605
	],
	"./nl.json": [
		4943,
		943
	],
	"./pt.json": [
		7741,
		741
	],
	"./ro.json": [
		2354,
		354
	],
	"./tr.json": [
		9755,
		755
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;